<template>
  <div class="about">
    <page-header :title="$t('news.edit')" :desc="model.title">
      <li class="breadcrumb-item"><router-link :to="{name:'news.index'}">{{$tc('news.name', 2)}}</router-link></li>
      <li class="breadcrumb-item">{{model.title}}</li>
    </page-header>
    <page-content>
      <form @submit.prevent="onSubmit">
        <ntm-block :title="$tc('image.name', 1)" :collapsable="false">
          <template slot="options">
            <span>{{ $t('ratio') }}: <span class="font-weight-bold">16:10</span>, {{ $t('size') }}: <span class="font-weight-bold">800x500 - 1280x800</span></span>
          </template>
          <ntm-crop :aspect-ratio="16/10" :max-width="1280" :max-height="800" :min-width="800" :min-height="500" conversion="meta" entity-type="news" :entity-uuid="$route.params.uuid" collection="preview"></ntm-crop>
        </ntm-block>
        <ntm-block>
          <formly-form :form="form" :model="model" :fields="fields"></formly-form>
        </ntm-block>
        <ntm-block>
          <div class="d-flex justify-content-start align-items-center mb-3">
            <button type="submit" class="btn mr-2" :class="{ 'btn-success': model.publishDate, 'btn-warning': !model.publishDate }">{{model.publishDate ? $t('saveAndPublish') : $t('saveAsDraft')}}</button>
            <button type="button" class="btn btn-danger" @click="deleteNews">{{ $t('action.delete') }}</button>
          </div>
        </ntm-block>
      </form>
    </page-content>
  </div>
</template>

<script>
import fields from './formDefinition'
import router from '@/router'
import NewsService from '../../services/news.service'
import Swal from 'sweetalert2'
import VueI18n from '@/i18n'

export default {
  // required properties, field, form, model
  data () {
    return {
      form: {},
      model: {},
      fields: fields
    }
  },
  beforeRouteEnter (to, from, next) {
    NewsService.show(to.params.uuid).then((response) => {
      next(vm => vm.setData(response.data))
    })
  },
  mounted () {
    const contentField = this.fields.find(field => field.key === 'content')
    contentField.templateOptions.uuid = this.model.uuid
    contentField.templateOptions.assetType = 'news'
  },
  methods: {
    setData (data) {
      this.model = {
        ...data,
        highlightEnabled: !!data.highlightUntil,
        announcementEnabled: !!data.announcementUntil
      }
    },
    onSubmit () {
      const data = { ...this.model }
      if (!data.highlightEnabled) {
        data.highlightUntil = null
      }
      if (!data.announcementEnabled) {
        data.announcementUntil = null
        data.announcementType = null
      }
      NewsService.update(this.model.uuid, data).then((response) => {
        router.push({ name: 'news.index' })
      }).catch((err) => {
        this.form.$errors = err.response.data.errors
      })
    },
    deleteNews () {
      Swal.fire({
        title: VueI18n.t('swal.delete.title'),
        text: VueI18n.t('swal.delete.text'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: VueI18n.t('swal.delete.yes'),
        cancelButtonText: VueI18n.t('swal.delete.no')
      }).then((result) => {
        if (result.value) {
          NewsService.destroy(this.model.uuid).then(() => {
            router.push({ name: 'news.index' })
          })
        }
      })
    }
  }
}
</script>
